import { HEALF_OPS_SUPPORT_EMAIL } from "src/constants/emails";
import { EmailLink } from "./ui";

const SuccessMessage: React.FC = () => (
  <div>
    <p>Thank you for your submission</p>
    <p>We appreciate your help in keeping our operations smooth</p>
    <p>We look forward to future collaboration</p>
  </div>
);

const ActionRequiredMessage: React.FC = () => (
  <div>
    <p>
      Further action is required, please contact: <EmailLink email={HEALF_OPS_SUPPORT_EMAIL} /> for next steps
    </p>
    <p>We appreciate your help in keeping our operations smooth</p>
  </div>
);

const WarnMessage: React.FC = () => (
  <div>
    <p>Are you sure you want to do that?</p>
    <p>Please confirm before proceeding</p>
  </div>
);

const ForbiddenMessage: React.FC = () => (
  <div>
    <p>Sorry, you don't have permission to access this</p>
    <p>
      To request access, please contact: <EmailLink email={HEALF_OPS_SUPPORT_EMAIL} />
    </p>
  </div>
);

const ErrorMessage: React.FC = () => (
  <div>
    <p>An error has occurred</p>
    <p>
      If this error persists, please contact: <EmailLink email={HEALF_OPS_SUPPORT_EMAIL} />
    </p>
    <p>We appreciate your help in keeping our operations smooth</p>
  </div>
);

const AuthorisationErrorMessage: React.FC = () => (
  <div>
    <p>Unable to authorise user. Check your internet connection</p>
    <p>
      If this error persists, please contact: <EmailLink email={HEALF_OPS_SUPPORT_EMAIL} />
    </p>
  </div>
);

const FileLoadErrorMessage: React.FC = () => (
  <div>
    <p>Unable to load file. Check your internet connection</p>
    <p>
      If this error persists, the file may be lost. Please contact: <EmailLink email={HEALF_OPS_SUPPORT_EMAIL} />
    </p>
    <p>We appreciate your help in keeping our operations smooth</p>
  </div>
);

const DataFetchErrorMessage: React.FC = () => (
  <div>
    <p>Unable to load data. Check your internet connection</p>
    <p>
      If this error persists, please contact: <EmailLink email={HEALF_OPS_SUPPORT_EMAIL} />
    </p>
    <p>We appreciate your help in keeping our operations smooth</p>
  </div>
);

const SubmissionErrorMessage: React.FC = () => (
  <div>
    <p>We couldn't complete your request. Check your internet connection</p>
    <p>
      If the error persists, contact: <EmailLink email={HEALF_OPS_SUPPORT_EMAIL} />
    </p>
    <p>We appreciate your help in keeping our operations smooth</p>
  </div>
);

const UpdateErrorMessage: React.FC = () => (
  <div>
    <p>Update Failed. Check your internet connection</p>
    <p>
      If this error persists, please contact: <EmailLink email={HEALF_OPS_SUPPORT_EMAIL} />
    </p>
    <p>We appreciate your help in keeping our operations smooth</p>
  </div>
);

export const StatusMessages = {
  Success: SuccessMessage,
  ActionRequired: ActionRequiredMessage,
  Warn: WarnMessage,
  Forbidden: ForbiddenMessage,
  Error: ErrorMessage,
  AuthorisationError: AuthorisationErrorMessage,
  FileLoadError: FileLoadErrorMessage,
  DataFetchError: DataFetchErrorMessage,
  SubmissionError: SubmissionErrorMessage,
  UpdateError: UpdateErrorMessage
};
